import React from 'react';
import NoThinkFashion from './NoThinkFashion';

function App() {
  return <NoThinkFashion />;
}

export default App;
